import { useAbsoluteRouteMatch } from '../../../utils/routing/useAbsoluteRouteMatch.hooks'
import { useNavHierarchySettingsV3 } from './useNavHierarchySettingsV3'

// True when the current route is part of the v3 Settings hierarchy. Single source
// of truth shared by the L2 settings rail (which uses it to self-show) and the
// v3 shell (which uses it to hide the L1 rail).
export const useIsOnSettingsRoute = (): boolean => {
  const routeMatch = useAbsoluteRouteMatch()
  const { indexedRoutes } = useNavHierarchySettingsV3()
  return !!(routeMatch?.route && indexedRoutes[routeMatch.route])
}
